export enum CollectionStatus {
	FAILED = "failed",
	PENDING = "payment-pending",
	SUCCESSFUL = "successful",
}
